<template>
  <div>
    <h5>Накладная</h5>
    <table class="table table-sm table-striped invoice_trace_table" v-if="trace">
      <thead>
      <tr>
        <th></th>
        <th>Действие</th>
        <th></th>
        <th>Дата</th>
        <th>Пользователь</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(record, index) in getInvoiceRecords()" :key="index">
        <td>{{ index + 1 }}</td>
        <td>
          {{ traceActions[record.action] ?? `Не определено (${record.action})` }}
        </td>
        <td>
          <div v-html="printTraceDetail(record)"></div>
        </td>
        <td>{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}</td>
        <td>{{ users[record.user_id] || 'Автоматически' }}</td>
      </tr>
      </tbody>
    </table>

    <div v-if="true">
      <div class="flex justify-content-between">
        <h5>Препараты</h5>
        <div v-if="invoiceType === 'income'">
          <label>
            <input type="checkbox" v-model="showDiff" @change="updateRecords"> показать изменения после приемки
          </label>
        </div>
      </div>
      <table class="table table-sm table-bordered table-hover drugs_trace_table" v-if="trace">
        <thead>
        <tr>
          <th></th>
          <th v-bind:class="{pointer: true, active: sorting.field === 'name'}" @click="updateSorting('name')">Препарат
            <i class="icon-fa icon-fa-sort-amount-desc"></i></th>
          <th v-bind:class="{pointer: true, active: sorting.field === 'created_at'}" @click="updateSorting('created')"
              width="170">Действие, Дата <i class="icon-fa icon-fa-sort-amount-desc"></i></th>
          <th>Количество</th>
          <th>Стоимость</th>
          <!--          <th v-if="invoiceType && invoiceType == 'transit'">Пожелание получателя</th>-->
          <!--          <th v-if="invoiceType && invoiceType == 'transit'">Пожелание отправителя</th>-->
          <th>Пользователь</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(record, index) in records">
          <tr>
            <td :rowspan="record.trace.length">{{ index + 1 }}</td>
            <td :rowspan="record.trace.length">{{ record.drug && record.drug.title }}
              ({{ record.drug && record.drug.id }})
            </td>
            <td>
              <p>{{ traceActions[record.trace[0].action] || 'Не определено' }}</p>
              <p class="text-muted">{{ printDate(record.trace[0].created_at) }}</p>
            </td>
            <td>{{ record.trace[0].qty }}</td>
            <td>{{ record.trace[0].income_price ?? record.trace[0].price }}</td>
            <!--            <td v-if="invoiceType && invoiceType == 'transit'"></td>-->
            <!--            <td v-if="invoiceType && invoiceType == 'transit'"></td>-->
            <td>{{ users[record.trace[0].user_id] || 'Автоматически' }}</td>
          </tr>
          <tr v-for="(trace, index) in record.trace" v-if="index > 0">
            <td>
              <p>{{ traceActions[trace.action] || 'Не определено' }}</p>
              <p class="text-muted">{{ printDate(trace.created_at) }}</p>
              <td>{{ trace.qty }}</td>
              <td>{{ trace.income_price ?? trace.price }}</td>
              <!--            <td v-if="invoiceType && invoiceType == 'transit'"></td>-->
              <!--            <td v-if="invoiceType && invoiceType == 'transit'"></td>-->
              <td>{{ users[trace.user_id] || 'Автоматически' }}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

import moment from "moment";

export default {
  props: ['trace', 'traceActions', 'users', 'invoiceType', 'traceDrugs'],
  data() {
    return {
      showDiff: false,
      sorting: {
        field: 'name',
        sort: 'desc'
      },
      records: [],
      subStatuses: {
        1: 'Накладная собрана'
      },
      statuses: {
        1: 'предварительная ведомость',
        2: 'в дороге',
        3: 'модерация',
        5: 'резерв',
        6: 'проверка приемки',
        7: 'приемка',
        0: 'фактическое поступление'
      }
    }
  },
  watch: {
    'trace': {
      handler: function (val, oldVal) {
        this.updateSorting('name');
      },
      deep: true
    }
  },
  mounted() {
    // this.records = [...this.trace];
    this.updateSorting('name');
  },
  methods: {
    updateRecords() {
      // console.log(this.showDiff);
      if (this.showDiff) {

        let startEditTime = this.trace.filter((t) => t.object === 'invoice').find((r) => +r.action === 1 && +r.new_value === 6)?.created_at;
        console.log(startEditTime);
        if (startEditTime) startEditTime = moment(startEditTime);
        this.records = this.records.filter((r) => {
          let setQty = [...r.trace].reverse().find((t) => t.action === 5 && !t.user_id);
          let changeQty = [...r.trace].reverse().find((t) => t.action === 21 && t.user_id === 248);
          // if (r.drug?.id === 77722497) {
            // console.log(setQty.created_at, setQty);
            // console.log(changeQty.created_at, changeQty);
            // console.log(startEditTime, moment(changeQty.created_at), moment(changeQty.created_at).isAfter(startEditTime));
          // }
          if (changeQty && moment(changeQty.created_at).isBefore(startEditTime)) {
            // if (r.drug?.id === 7771175) {
            //   console.log('skip', moment(changeQty.created_at));
            // }
            return false;
          }
          if (setQty) {
            if (changeQty && changeQty.qty !== setQty.qty) return true;
          } else {
            setQty = [...r.trace].reverse().find((t) => t.action === 2);
            if (changeQty && changeQty.qty !== setQty.qty) return true;
          }

          if (startEditTime) {
            if (r.trace.find((t) => t.action !== 22 && moment(t.created_at).isAfter(startEditTime))) return true;
          }
          return false;
        });
      } else {
        this.sorting = {
          field: 'name',
          sort: 'desc'
        };
        this.updateSorting('name');
      }
    },
    getInvoiceRecords() {
      return this.trace.filter((t) => t.object == 'invoice');
    },
    isInvoiceRecord(record) {
      return record.object == 'invoice';
    },
    printTraceDrug(data) {
      let text = '';
      data.forEach((record) => {
        text += '<p>Количество: <strong>' + record.qty + '</strong> Стоимость: <strong>' + record.income_price + '</strong> Со скидкой: <strong>' + record.price + '</strong> <strong class="' + (record.action == 3 ? "badge badge-warning" : '') + '">' + this.traceActions[record.action] + '</strong></p>';
      })
      return text;
    },
    updateSorting(field) {
      let drugs = {};
      [...this.trace].forEach((t) => {
        if (t.object == 'drug') {
          if (!drugs[t.object_id]) {
            drugs[t.object_id] = {
              'drug': this.traceDrugs && this.traceDrugs[t.object_id],
              'trace': [],
            }
          }
          if (!(t.action === 21 && t.qty === null)) {
            drugs[t.object_id].trace.push(t);
          }
          drugs[t.object_id].created_at = t.created_at;
        }
      })
      if (this.sorting.field === field) {
        this.sorting.sort = this.sorting.sort === 'asc' ? 'desc' : 'asc';
      } else {
        this.sorting = {
          field: field,
          sort: 'asc'
        }
      }
      let sortField;
      switch (field) {
        case 'name':
          sortField = 'drug.title';
          break;
        case 'created':
          sortField = 'created';
          break;
      }
      this.records = _.orderBy(drugs, sortField, this.sorting.sort);
    },
    printTraceDetail(detail) {
      let text = '';
      switch (detail.action) {
        case 23:
        case 24:
          text += '<p>' + (+detail.new_value ? `<strong>подтверждено</strong>` : `<strong>сброшено</strong>`);
          if (detail.data?.user) {
            text += ' (' + detail.data.user + ')';
          }
          text += '</p>';
          break;
        case 14:
          text += '<p>' + detail.data.message + '</p>';
          (detail?.data?.extraData ?? []).forEach((d) => {
            if (d && d.id) {
              text += '<p>заявка: <strong>' + d.id + '</strong></p>';
            }
          })
          break;
        case 4:
          text += '<p>Накладная создана в системе</p>';
          text += '<p><strong>' + this.statuses[detail.data.status] + '</strong></p>';
          if (detail.data.comment) {
            text += '<p>Комментарий: ' + detail.data.comment + '</p>';
          }
          if (detail.data.discount) {
            text += '<p>Скидка: <strong>' + detail.data.discount + '</strong>' + (detail.data.discount_type == 2 ? ' у.е.' : '%') + '</p>';
          }
          if (detail.data.delivery_date) {
            text += '<p>Доставка: <strong>' + detail.data.delivery_date + '</strong></p>';
          }
          break;
        case 1:
          switch (detail.data.object) {
            case 'discount_type':
              text += 'Установлен тип скидки: <strong>' + (detail.data.new_value == 1 ? 'Общая сумма в валюте накладной' : 'Процент с каждой позиции') + '</strong>';
              break;
            case 'discount':
              text += 'Установлена скидка: <strong>' + detail.data.new_value + '</strong>';
              break;
            case 'status':
              text += 'Установлен статус: <strong>' + (this.statuses[detail.data.new_value] || 'не определен') + '</strong>';
              break;
          }
          if (detail.data.sub_action) {
            text += this.traceActions[detail.data.sub_action];
            switch (detail.data.sub_action) {
              case 13:
                if (detail.old_value) {
                  text += '<p class="text-muted">' + detail.old_value + '</p>';
                }
                text += '<p>' + detail.new_value + '</p>';
                break;
              case 12:
                text += ': <strong>' + this.statuses[detail.new_value] + '</strong>';
                if (detail.data.sub_status) {
                  text += `<p>${this.subStatuses[detail.data.sub_status]}</p>`;
                }
                break;
              case 9:
                text += ': ' + detail.new_value;
                break;
            }
          }
          break;
        case 2:
          text += detail.drug_info.prep + ' количество: <strong>' + detail.qty + '</strong>';
          if (detail.price) {
            text += ' стоимость: <strong>' + detail.price + '</strong>';
          }
          break;
        case 5:
        case 7:
          text += detail.drug_info.prep + ' - ' + detail.old_value + ' / <strong>' + detail.new_value + '</strong>';
          break;
      }
      return text;
    }
  }
}

</script>

<style>
.invoice_trace_table p {
  margin-bottom: 2px;
}
</style>

<style scoped>
.drugs_trace_table td {
  padding: 3px 10px;
}

th.active {
  font-weight: 700;
  font-size: 15px;
}

.table p {
  margin-bottom: 2px;
}

.table .text-muted {
  font-size: 10px;
}
</style>
